import { createContext } from "react";
import { ApiService } from "../../services/api/service";
import { AppType } from "./type";
import { PerspectiveApiService } from "../../services/perspective_api/service";

const defaultValue: AppType = {
  apiService: ApiService.getInstance(),
  perspectiveApiService: PerspectiveApiService.getInstance(),
  selectedCustomerId: null,
  setSelectedCustomerId: () => {},
  customerSettings: null,
  licensesRegistered: false,
  whoIAm: null,
  actualRole: null,
  loading: false,
  allCustomers: [],
  isAdmin: false,
  // Demo mode state
  demoMode: false,
  setDemoMode: () => {},
  // WASM state - will be initialized by provider
  wasmInitialized: false,
  wasmError: null,
  // Locked run state
  lockedRun: null,
  // Refetch function
  refetchCustomerSettings: () => {},
};

export const ApiContext = createContext(defaultValue);
